
<div *ngIf="transclude">
  <div class="alert alert-success">
    <button class="close" type="button" aria-label="Close" (click)="hideTransclusion()"><span aria-hidden="true">&times;</span></button>
    <ng-content></ng-content>
  </div>
</div>
<div *ngIf="messages.length">
  <div class="alert alert-success" *ngFor="let message of messages; let i = index;">
    <button class="close" type="button" aria-label="Close" (click)="close(i);"><span aria-hidden="true">&times;</span></button><span class="font-weight-bold float-left">Success:  &nbsp;</span><span class="float-left"><span>{{ message }}</span></span>
    <div class="clearfix"></div>
  </div>
</div>